import type { NextRouter } from 'next/router';

import { hasInternalRedirect, isInternalPath } from './isInternalRedirect';

const isApplyPath = (path: unknown) =>
  isInternalPath(path) &&
  /^\/(?:[^/?#]+\/)*(?:opportunities\/(?:jobs|s)|jobs)\/[^/]+(?:\/[^/]+)?\/apply\/?$/.test(
    path.split(/[?#]/)[0]
  );

export const isApplyFlow = ({
  asPath,
  query,
}: Pick<NextRouter, 'asPath' | 'query'>): boolean => {
  if (
    (query.next !== undefined || query.nextAs !== undefined) &&
    !hasInternalRedirect(query)
  ) {
    return false;
  }
  const nextAs = query.nextAs;

  return isApplyPath(asPath) || Boolean(nextAs && isApplyPath(nextAs));
};
